<template>
  <NaviButtonDropdown
    label=""
    class="navi-button-setting"
  >
    <template #label="{ isOpen }">
      <i class="navi-button-setting-icon icon-font-gear" />
      <NaviIconArrow :direction="isOpen ? 'up' : 'down'" />
    </template>
    <ul class="navi-button-setting-list">
      <li
        v-for="{ label, href, ...attrs } in props.list"
        :key="label"
      >
        <a
          :href="href"
          v-bind="attrs"
        >{{ label }}</a>
      </li>
      <li>
        <button
          type="button"
          @click="handlePostFormLogout"
        >
          登出
        </button>
      </li>
      <li
        v-for="{ label, href, ruleValidator, ...attrs } in props.adminList"
        :key="label"
        class="navi-button-setting-admin-list-item"
      >
        <a
          v-if="shoulShowAdminListItem(ruleValidator)"
          :href="href"
          v-bind="attrs"
        >{{ label }}</a>
      </li>
    </ul>
  </NaviButtonDropdown>
</template>

<script setup>
import useUserStore from '@/modules/shared/store/useUserStore'

import NaviButtonDropdown from './NaviButtonDropdown.vue'
import NaviIconArrow from './NaviIconArrow.vue'

const props = defineProps({
  list: {
    type: Array,
    required: true,
    validator(value) {
      return value.every((option) => (
        ['label', 'href'].every((requiredKey) => (
          Object.keys(option).includes(requiredKey)
        ))
      ))
    },
  },
  adminList: {
    type: Array,
    required: true,
    validator(value) {
      return value.every((option) => (
        ['label', 'href', 'ruleValidator'].every((requiredKey) => (
          Object.keys(option).includes(requiredKey)
        ))
      ))
    },
  },
})

const { currentUser } = useUserStore()
const shoulShowAdminListItem = (ruleValidator) => (
  typeof ruleValidator === 'function'
    ? ruleValidator({ currentUser })
    : false
)

const handlePostFormLogout = () => {
  const csrfParamName = document.querySelector('meta[name=csrf-param]').content
  const csrfToken = document.querySelector('meta[name=csrf-token]').content
  const fromDom = document.createElement('form')
  fromDom.setAttribute('method', 'post')
  fromDom.setAttribute('action', '/users/sign_out')
  fromDom.innerHTML = `
    <input type="hidden" name="_method" value="delete" />
    <input type="hidden" name="${csrfParamName}" value="${csrfToken}" />
  `
  document.body.appendChild(fromDom)
  fromDom.submit()
}
</script>

<style scoped lang="scss">
.navi-button-setting {
  :deep(.navi-button-dropdown-wrapper) {
    left: -44px;
  }
  :deep(.navi-button-dropdown-pointer) {
    left: 60px;
  }

  ul li {
    text-align: center;
  }
}
.navi-button-setting-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
}
.navi-button-setting-admin-list-item {
  background: #eee;
}
</style>
